import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SIRGPD_EST_CRD;

export default {
  read(payload) {
    return baseApi.post(resource, payload);
  },

  read1(payload) {
    return baseApi.post(`${resource}1`, payload);
  },
};
